// pc store
import mainStore from './components/main/store';
import inviteDialogStore from './components/inviteDialog/store';
import appManageDialogStore from './components/main/appManage/store';
import { headerMenuStore, headerTenantStore } from './components/main/navigation/store';
import createTeamsStore from './components/main/createTeams/store';
import reloginStore from './components/reloginDialog/store';
import teamSharingListStore from './components/common/teamShareList/store';
import importDataComStore from './components/inviteDialog/importData/store';

// mobile store
import mobMainStore from './components/mobile/store';
import mobAppManageStore from './components/mobile/appManage/store';
import mobFeedbackStore from './components/mobile/workbanch/Feedback/store';
import mobRecommendStore from './components/mobile/workbanch/Recommend/store';
import mobTeamsStore from './components/mobile/workbanch/Teams/store';
import mobInviteStore from './components/mobile/invite/store';
import mCreateTeamStore from "./components/mobile/workbanch/createTeam/store";
import mobAppQrcodeStore from './components/mobile/appQrcode/store';
import mobTeamShareStore from './components/mobile/teamsShare/store';
import mobTeamShareListStore from './components/common/m/mobTeamsShareList/store';
import mobSubscribeTransferStore from './components/mobile/subscribeTransfer/store';

const pcStores = {
  mainStore,
  inviteDialogStore,
  headerMenuStore,
  headerTenantStore,
  appManageDialogStore,
  createTeamsStore,
  reloginStore,
  teamSharingListStore,
  importDataComStore
};

const mStores = {
  mobMainStore,
  mobFeedbackStore,
  mobRecommendStore,
  mobAppManageStore,
  mobTeamsStore,
  mobInviteStore,
  mCreateTeamStore,
  mobAppQrcodeStore,
  mobTeamShareStore,
  mobTeamShareListStore,
  mobSubscribeTransferStore
}

export {
  pcStores,
  mStores
};